<div  mat-dialog-content>
 
  <div class="fixed z-10 inset-0 overflow-y-auto overflow-scroll">
  
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        <div 
            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <svg xmlns="http://www.w3.org/2000/svg"  [mat-dialog-close]="true"  class="w-9 h-9 flex absolute right-5 "  viewBox="0 0 24 24"><path fill="purple" d="M12 3c-4.963 0-9 4.038-9 9s4.037 9 9 9s9-4.038 9-9s-4.037-9-9-9m0 16c-3.859 0-7-3.14-7-7s3.141-7 7-7s7 3.14 7 7s-3.141 7-7 7m.707-7l2.646-2.646a.502.502 0 0 0 0-.707a.502.502 0 0 0-.707 0L12 11.293L9.354 8.646a.5.5 0 0 0-.707.707L11.293 12l-2.646 2.646a.5.5 0 0 0 .707.708L12 12.707l2.646 2.646a.5.5 0 1 0 .708-.706z"/></svg>
           
            <h1 class="text-center p-3 text-2xl font-bold text-black m-3">Select Delivery Address</h1>
            
            <div class="sm:flex sm:items-start border-2 border-purple-700 mb-3 p-3 rounded-lg " *ngFor="let item of addressData;">
                <div 
                    class="mx-auto flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-purple-200 sm:mx-0 sm:h-10 sm:w-10">
                    <input type="radio" (change)="selectAddress(item?._id)" name="address" id="address" class="w-6 h-6" >
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"  >
                    <h3 class=" lg:flex inline-block text-lg leading-6 font-medium text-black">
                      {{ item?.delivery_name}} ( {{ item?.delivery_mobile}})</h3>
                    <div class="mt-2">
                        <p class="text-sm leading-5 text-gray-800">
                          {{ item?.delivery_address}}  {{ item?.delivery_city}} {{ item?.delivery_pincode}}  {{ item?.delivery_state}}{{ item?.delivery_country}}
                        </p>
              
                        <span > 
                           <div class="flex mt-5 sm:mt-4 sm:flex sm:flex">
                          <span class="flex w-full rounded-md shadow-sm sm:ml-1 sm:w-auto">
                              <button type="button"   (click)="editAddress(item._id)"
                                  class="btncolor inline-flex justify-center w-full m-2 rounded-md border border-transparent px-2 py-2  font-semibold text-white shadow-sm focus:outline-none focus:shadow-outline-green transition ease-in-out duration-150 ">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" viewBox="0 0 24 24"><path fill="white" d="M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83l-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35l2.83 2.83l-1.42 1.42l-2.83-2.83ZM8 13.17l5.93-5.93l2.83 2.83L10.83 16H8Z"/></svg>
  
                                  Edit
                              </button>
                          </span>
                          <span class="xs:mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                            <button type="button"  (click)="deleteAddress(item._id)"
                            class="btncolor inline-flex justify-center w-full m-2 rounded-md border border-transparent px-2 lg:ml-2 py-2  font-semibold text-white shadow-sm focus:outline-none focus:shadow-outline-green transition ease-in-out duration-150 ">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" viewBox="0 0 16 16"><path fill="white" fill-rule="evenodd" d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clip-rule="evenodd"/></svg>
                            Remove
                        </button>
                          </span>
                      </div>
                        </span>
                    </div>
                </div>
              
            </div>
          
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" >
                  <button type="button" [mat-dialog-close]="true" (click)="setDefaultAddress()"
                  class="btncolor inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2  font-semibold text-white shadow-sm focus:outline-none focus:shadow-outline-green transition ease-in-out duration-150">
                  Select
                </button>
                </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" (click)="addressUpdate()"
                        class="btncolor inline-flex justify-center w-full text-white p-3 rounded-lg border border-gray-300 px-4 py-2 bg-white text-base leading-6   font-semibold shadow-sm  focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        Add Address
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>

</div>

                